<template>
  <FormPetition
    v-if="!document?.closed"
    :petition-id="props.formComponent?.identification as string"
    :db-override="document.dbOverride || ''"
    :is-protest="isProtest"
    :endpointId="document?.endpoint?.sys?.id"
    :campaignCode="document?.actionCode"
    :description="document?.excerpt"
    class="mt-4"
    :is-minimize="true"
    :mailTemplate="document?.mailTemplate"
    :mailTo="document?.mailTo"
    @update:current-step="handleCurrentStep"
  />
</template>

<script lang="ts" setup>
import type { ActionDocument } from '../../../types/contentfulCms'
import FormPetition from '@/components/molecules/FormPetition.vue'
import { useAsyncData, useNuxtApp } from '#app'

const { $client } = useNuxtApp()

const props = defineProps({
  formComponent: Object,
})

const emit = defineEmits<{
  'update:currentStep': [step: number]
}>()

const { data: dataContentful } = await useAsyncData(
  `petition--${props.formComponent?.identification}`,
  () =>
    $client.getEntries({
      content_type: 'action',
      'fields.slug': props.formComponent?.identification,
      limit: 1,
    }),
)

const document = (dataContentful?.value?.items[0]?.fields || {}) as unknown as ActionDocument
const isProtest = Boolean(document?.mailTemplate)

const handleCurrentStep = (step: number) => {
  emit('update:currentStep', step)
}
</script>
